import { getDateKey } from "shared/utils/date";

type Params = {
  seconds: number;
  sessionDateKey: string;
};

export const useStopwatchWarnings = ({ seconds, sessionDateKey }: Params) => {
  const today = getDateKey();
  const isPreviousDaySession = seconds > 0 && sessionDateKey !== today;
  const stopwatchWarning = isPreviousDaySession
    ? "This paused session belongs to a previous day. Please Save or Reset it before continuing."
    : null;
  return { isPreviousDaySession, stopwatchWarning };
};

